<iframe [src]="data.url"></iframe>